var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 21H10.25C10.25 22.1 9.35 23 8.25 23C7.15 23 6.25 22.1 6.25 21ZM4.25 19C4.25 19.55 4.7 20 5.25 20H11.25C11.8 20 12.25 19.55 12.25 19C12.25 18.45 11.8 18 11.25 18H5.25C4.7 18 4.25 18.45 4.25 19ZM15.75 10.5C15.75 14.32 13.09 16.36 11.98 17H4.52C3.41 16.36 0.75 14.32 0.75 10.5C0.75 6.36 4.11 3 8.25 3C12.39 3 15.75 6.36 15.75 10.5ZM20.62 8.37L19.25 9L20.62 9.63L21.25 11L21.88 9.63L23.25 9L21.88 8.37L21.25 7L20.62 8.37ZM18.25 7L19.19 4.94L21.25 4L19.19 3.06L18.25 1L17.31 3.06L15.25 4L17.31 4.94L18.25 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeIcon);
export default __webpack_public_path__ + "static/media/CreativeIcon.e1a846e816a98ad9bbfbe8c03ffd663c.svg";
export { ForwardRef as ReactComponent };